import { Injectable, inject } from '@angular/core';
import { HttpRequestService } from '../http-request/http-request.service';
import { registerLocaleData } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { arLanguage, enLanguage } from '@waseel-asp/tpa-waseel-lib-staging';
import { API } from '../../constants/api-url';
import { LanguageType } from '../../constants/language-eum';
import { LoaderService } from '../loader/loader.service';
import { LanguageService } from '../translation/language.service';
import localeAr from '@angular/common/locales/ar';
import localeEn from '@angular/common/locales/en';
import { TranslationService } from '@waseel-asp/tpa-waseel-lib-staging';
import { Resolve } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageResolverService implements Resolve<any> {
  private httpRequestService = inject(HttpRequestService);
  private translation = inject(TranslationService);
  private loaderService = inject(LoaderService);
  private authService = inject(AuthService);
  private languageService = inject(LanguageService);
  private translate = inject(TranslateService);

  private translationsLoaded = false;

  resolve(): Promise<void> {
    if (this.translationsLoaded)
      return Promise.resolve();

    const currentLanguage = this.languageService.getLanguage();
    return new Promise((resolve, reject) => {
      this.loadAndMergeLanguage(currentLanguage, this.authService.isLoggedIn())
        .then(() => resolve())
        .catch(() => reject());
    });

  }

  async loadAndMergeLanguage(currentLanguage: string, getServerResource: boolean = true, hideLoader: boolean = false): Promise<void> {
    const backendEngLanguage$ = this.httpRequestService.get<Record<string, string>, null>(
      `${API.LANG_RESOURCE_JSON}?language=${LanguageType.getDescription(LanguageType.English)}`
    );
    const backendArbLanguage$ = this.httpRequestService.get<Record<string, string>, null>(
      `${API.LANG_RESOURCE_JSON}?language=${LanguageType.getDescription(LanguageType.Arabic)}`
    );

    this.translate.setTranslation(LanguageType.Arabic, arLanguage, true);
    this.translate.setTranslation(LanguageType.English, enLanguage, true);

    if (getServerResource) {
      const [backendEnglishLang, backendArabicLang] = await Promise.all([
        backendEngLanguage$.toPromise(),
        backendArbLanguage$.toPromise()
      ]);

      this.translate.setTranslation(LanguageType.Arabic, backendArabicLang, true);
      this.translate.setTranslation(LanguageType.English, backendEnglishLang, true);
    }
    await this.useAndSetLanguage(currentLanguage, hideLoader);
    return Promise.resolve();
  }

  loadLocale(currentLanguage: string) {
    registerLocaleData(currentLanguage === 'ar' ? localeAr : localeEn);
  }

  private useAndSetLanguage(currentLanguage: string, hideLoader: boolean): Promise<boolean> {
    return new Promise((resolve) => {
      this.loadLocale(currentLanguage);
      this.translate.use(currentLanguage);
      this.translation.setLanguage(currentLanguage).then(() => {
        if (hideLoader)
          this.loaderService.hide();
        this.languageService.setLanguageReady(true);
        resolve(true);
      });
    });
  }

}